import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import account from '@/services/auth/account';
import createApiError from '@/utils/api/createError';
const PREFIX = 'services: api: users:';
const API_DOMAIN = process.env.NEXT_PUBLIC_FIREBASE_FUNCTIONS_DOMAIN;
const generateCreateError = createApiError(`${PREFIX} createRecord:`);

// POST request to create a new user
const postRequest = (reCaptchaToken, body) => fetch(`${API_DOMAIN}/api/v0/users`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(_objectSpread(_objectSpread({}, body), {}, {
    'g-recaptcha-response': reCaptchaToken
  }))
}); // Create new user request


const createRecord = async (reCaptchaToken, data) => {
  let response;

  try {
    response = await postRequest(reCaptchaToken, data);
  } catch (err) {
    throw Error(`${PREFIX} createRecord: POST request failed: ${err}`);
  }

  let responseJson = {};

  if (response.status !== 204) {
    try {
      responseJson = await response.json();
    } catch (err) {
      throw Error(`${PREFIX} createRecord: failed to parse JSON: ${err}`);
    }
  } // Throw unsuccessful request API error


  const apiError = generateCreateError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }

  const isExpected = responseJson.data && responseJson.data.attributes;

  if (!isExpected) {
    throw Error(`${PREFIX} createRecord: unexpected response payload`);
  }

  return _objectSpread(_objectSpread({}, responseJson.data.attributes), {}, {
    id: responseJson.data.id
  });
};

export default {
  createRecord
};